import { DocumentData } from '@firebase/firestore';
import { Tooltip } from '@mui/material';
import { DataGrid, GridCellParams, GridColDef, GridRowId, GridRowModel } from '@mui/x-data-grid';
import { IconButton, SideSheet, majorScale, toaster } from 'evergreen-ui';
import { useEffect, useState } from 'react';
import { FiEdit2 } from 'react-icons/fi';
import { IoIosExpand } from 'react-icons/io';
import { ProjectsToolbar } from '../components/ProjectToolbar';
import { DeleteDialog } from '../containers/DeleteDialog';
import { ProjectAdd } from '../containers/ProjectAdd';
import { ProjectDetails } from '../containers/ProjectDetails';
import { DeleteProjects, GetProjects } from '../services/ProjectService';

export default function Projects() {

    const [isShown, setIsShown] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [projects, setProjects] = useState<DocumentData[]>([]);
    const [selectedID, setSelectedID] = useState<GridRowId[]>([]);
    const [editData, setEditData] = useState<GridRowModel>();
    const [isLoading, setIsLoading] = useState(true);
    const [showProuctInfo, setShowProjectInfo] = useState(false);
    const [projectInfo, setProjectInfo] = useState<GridRowModel>()

    const columns: GridColDef[] = [
        {
            field: '',
            headerName: 'Actions',
            disableColumnMenu: true,
            hideSortIcons: true,
            renderCell: (params: GridCellParams) => (
                <>
                    <Tooltip title='Edit Project'>
                        <IconButton icon={FiEdit2} intent="success" marginRight={majorScale(1)} onClick={() => onEditData(params)} />
                    </Tooltip>
                    <Tooltip title='Open Project'>
                        <IconButton icon={IoIosExpand} intent="success" marginRight={majorScale(1)} onClick={() => onOpenDetails(params)} />
                    </Tooltip>
                </>
            )
        },
        { field: 'id', width: 100, headerName: 'ID' },
        { field: 'projectNameEn', width: 130, headerName: 'Project Name' },
        { field: 'projectNameAr', width: 200, headerName: 'Project Name Arabic' },
        {
            field: 'images', width: 130, headerName: 'Images',
            renderCell: (params: GridCellParams) => (
                <img src={params.row.images[0] as string} alt='images' />
            )
        },
        {
            field: 'descriptionEn', width: 200, headerName: 'Description',
            renderCell: (params: GridCellParams) => (
                <Tooltip title={params.row.descriptionAr} >
                    <span className="table-cell-trucate">{params.row.descriptionEn}</span>
                </Tooltip>
            )
        },
        {
            field: 'descriptionAr', width: 200, headerName: 'Description Arabic',
            renderCell: (params: GridCellParams) => (
                <Tooltip title={params.row.descriptionAr} >
                    <span className="table-cell-trucate">{params.row.descriptionAr}</span>
                </Tooltip>
            )
        }
    ];

    const getData = async () => {
        let data = await GetProjects();
        console.log(data);
        setProjects(data);
        setIsLoading(false);
    };

    useEffect(() => { getData() }, [])

    const onEditData = (params: any) => {
        setEditData(params.row);
        setIsShown(true)
    }

    const onOpenDetails = (params: any) => {
        setShowProjectInfo(true);
        setProjectInfo(params.row);
    }

    const onSheetClose = () => {
        setIsShown(false);
        setEditData({});
        getData();
    }

    const deleteRecord = async () => {
        console.log('Delete selected records', selectedID);
        const res = await DeleteProjects(selectedID as string[]);
        if (res.code === 200) {
            toaster.success(res.message);
        } else {
            toaster.danger(res.message);
        }
        setShowDelete(false);
        getData();
    }

    return (
        <div className="px-10 pt-5">
            <SideSheet isShown={isShown} onCloseComplete={onSheetClose} shouldCloseOnOverlayClick={false}>
                <ProjectAdd setIsShown={onSheetClose} editData={editData} />
            </SideSheet>
            <DeleteDialog showDelete={showDelete} setShowDelete={setShowDelete} deleteRecord={deleteRecord} />
            <ProjectDetails isShown={showProuctInfo} setIsShown={() => setShowProjectInfo(false)} projectInfo={projectInfo} />
            <div className='h-100 w-full bg-white' >
                <DataGrid
                    loading={isLoading}
                    rows={projects}
                    columns={columns}
                    components={{ Toolbar: ProjectsToolbar }}
                    componentsProps={{
                        toolbar: { setIsShown, selectedID, setShowDelete }
                    }}
                    onSelectionModelChange={(newSelectionModel) => { setSelectedID(newSelectionModel) }}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    checkboxSelection
                    disableSelectionOnClick
                />
            </div>
        </div >
    );
}
